<template>
	<div class="basic_wrap">
        <div class="top_nav">
            <van-icon name="arrow-left" class="back_icon" @click="$router.back()" />
            <div class="nav_title">{{$t('notice.message')}}</div>
        </div>
        
		<div class="main_content">
            <div class="msg_num">
                <div class="all_msg">{{$t('notice.unRead')}}: <span class="num_highlight">{{data.ok_read_num}}</span></div>
            </div>

            <div class="msg_box">
                <div class="m-card item" v-for="item in data.list" :key="item.id" @click="$router.push('/notice/'+item.id)">
                    <div class="item_header">
                        <div class="title_box">
                            <div class="icon_wrap">
                                <van-icon name="volume-o" class="notice_icon" />
                            </div>
                            <div class="tit van-ellipsis">{{item[title]}}</div>
                        </div>
                        <div class="time">{{item.time}}</div>
                    </div>
                    <div class="content van-multi-ellipsis--l2" v-html="item[content]"></div>
                </div>
                
                <van-empty v-if="!data.list || data.list.length === 0" :description="$t('item.noData')" />
            </div>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
    import Vue from 'vue';
    import { Empty, Icon } from 'vant';

    Vue.use(Empty).use(Icon);

	export default {
		name: "notice",
		data() {
			return {
				title:"title_"+ (this.$i18n.locale||"zh_cn"),
				content:"content_"+ (this.$i18n.locale||"zh_cn"),
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/notice').then((r) => {
					this.data = r.data;
				});
			},
		}
	};
</script>

<style lang="less" scoped>
    .basic_wrap {
        background-color: #F1F4F6;
        min-height: 100vh;
        padding-bottom: 20px;
    }

    .top_nav {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 46px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        
        .back_icon {
            position: absolute;
            left: 15px;
            font-size: 20px;
            color: #333;
            cursor: pointer;
        }
        
        .nav_title {
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
    }

    .main_content {
        padding: 46px 15px 15px;
    }

	.msg_num {
		width: 100%;
		height: 40px;
		display: flex;
		justify-content: space-between;
		align-items: center;
        margin-top: 10px;
        margin-bottom: 5px;
        
		.all_msg {
			font-size: 14px;
			color: #666;
            
			.num_highlight {
				color: #4F46E5;
                font-weight: bold;
                font-size: 16px;
                margin-left: 4px;
			}
		}
	}

    .m-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.02);
        padding: 16px;
        margin-bottom: 12px;
    }

	.msg_box {
		.item {
            cursor: pointer;
            transition: all 0.3s;
            
            &:active {
                transform: scale(0.98);
            }

            .item_header {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                margin-bottom: 12px;
                
                .title_box {
                    display: flex;
                    align-items: center;
                    flex: 1;
                    min-width: 0;
                    margin-right: 10px;
                    
                    .icon_wrap {
                        width: 28px;
                        height: 28px;
                        background: #eef2ff;
                        border-radius: 8px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 10px;
                        flex-shrink: 0;
                        
                        .notice_icon {
                            font-size: 16px;
                            color: #4F46E5;
                        }
                    }
                    
                    .tit {
                        font-size: 15px;
                        color: #333;
                        font-weight: bold;
                        flex: 1;
                    }
                }
                
                .time {
                    font-size: 12px;
                    color: #999;
                    white-space: nowrap;
                    margin-top: 6px;
                }
            }

			.content {
				font-size: 13px;
				color: #666;
                line-height: 1.6;
                
                /deep/ p {
                    margin: 0;
                }
                
                /deep/ img {
                    max-width: 100%;
                    height: auto;
                    display: none; // Hide images in preview
                }
			}
		}
	}
</style>